import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export const styles = css`
  .flex {
    display: flex;
  }
  .banner-row {
    width: 100%;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid ${colors.G2};
  }
  .title-wrapper {
    display: flex;
    align-items: center;
  }
  .advanced-banner-title {
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    font-weight: bold;
    margin: 0 14px 0 0;
  }
  .review-breakdown-container {
    display: none;
  }
  .banner-container {
    margin-bottom: 1px;
    display: flex;
    flex-direction: column;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 14px 24px;
  }
  .banner-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .overall-rating-container {
    justify-content: center;
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: row-reverse;
  }
  .overall-rating {
    font-size: 14px;
    line-height: 30px;
    padding-left: 4px;
  }
  .review-count {
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 0.2px;
    margin-right: 12px;
    white-space: nowrap;
  }
  .vehicle-image {
    display: none;
  }
  .breakdown-overall-rating {
    font-weight: 600;
  }
  .border {
    display: none;
  }
  @media (min-width: ${screen.xsMin}) {
    .banner-content {
      display: flex;
      max-width: 1440px;
    }
  }
  @media (min-width: 850px) {
    .banner-container {
      padding: 8px 24px;
    }
    .banner-content {
      justify-content: space-between;
    }
    .banner-row {
      height: 64px;
    }
    .advanced-banner-title {
      font-size: 20px;
      line-height: 28px;
    }
    .overall-rating-container {
      padding-right: 12px;
      display: flex;
      flex-direction: column;
    }
    .overall-rating {
      font-size: 20px;
      line-height: 24px;
    }
    .review-count {
      line-height: 24px;
    }
  }
  @media (min-width: ${screen.lgMin}) {
    .banner-row {
      height: 100px;
    }
    .review-category {
      min-width: 65px;
    }
    .review-breakdown-container {
      display: flex;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.2px;
      font-weight: 400;
      flex-wrap: wrap;
      align-content: center;
      justify-content: space-between;
      gap: 10px 0;
      padding-left: 16px;
      max-width: 330px;
      margin-right: 24px;
    }
    .border {
      display: flex;
      height: 52px;
      margin-top: 12px;
      width: 1px;
      background: ${colors.G2};
    }
    .vehicle-image {
      margin-right: 24px;
      display: flex;
      align-items: center;
    }
    .advanced-banner-vehicle-image {
      max-width: 164px;
      max-height: 72px;
    }
  }
`;
